import { createSlice } from "@reduxjs/toolkit";
import { ToiletCleanerProduct } from "../../Api/Api"; // Import API function

const toiletCleanerSlice = createSlice({
    name: "toiletCleaner",
    initialState: {
        products: [],  // Ensure initial state is an array
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(ToiletCleanerProduct.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ToiletCleanerProduct.fulfilled, (state, action) => {
                //console.log("Data Received in Redux:", action.payload);
                state.products = action.payload; // Ensure this is an array
                state.loading = false;
            })
            .addCase(ToiletCleanerProduct.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default toiletCleanerSlice.reducer;
